module.exports = __webpack_public_path__ + "img/XiangminHan.7d5b7550.jpg";